import SectionHead from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import { INDUSTRIES } from "@/lib/data";

export default function IndustriesSection() {
  return (
    <section data-testid="industries-section" className="relative py-24">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHead
          overline="Industries We Serve"
          title="Recruitment Across Industries"
          sub="Deep sourcing networks across technology, corporate and industrial talent markets."
          testid="industries-heading"
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.name} delay={(i % 4) * 0.06}>
              <div
                data-testid={`industry-card-${i + 1}`}
                className="group flex h-full items-center gap-3.5 rounded-2xl border border-white/[0.08] bg-[#0A0F1D]/60 px-5 py-5 transition-[border-color,transform,background-color] duration-500 hover:-translate-y-1 hover:border-cyan-400/30 hover:bg-[#0F172A]/70"
              >
                <ind.icon size={19} className="shrink-0 text-cyan-400/80 transition-colors duration-300 group-hover:text-cyan-300" />
                <span className="text-[13px] font-medium leading-snug text-slate-300">{ind.name}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
